import { apiBaseUrl } from 'APIs';
import { axios } from './interceptors/request.interceptor';

import {
  CreateTransaction,
  Transaction,
} from 'interfaces/Transaction.interface';

export const createTransaction = async (data: CreateTransaction) => {
  const url = `${apiBaseUrl}transaction`;
  return await axios.post<Transaction>(url, data);
};

export const getTransaction = async (from: string, to: string) => {
  const url = `${apiBaseUrl}transaction/${from}/${to}`;
  return await axios.get<Transaction>(url);
};

export const getProccessingTransactions = async (isProcessed: string) => {
  const url = `${apiBaseUrl}transaction/find/${isProcessed}`;
  return await axios.get<Transaction[]>(url);
};

export const deleteTransaction = async (hash: string) => {
  const url = `${apiBaseUrl}transaction/${hash}`;
  return await axios.delete<Transaction>(url);
};

export const updateTransactionProcessing = async (
  isProcessed: boolean,
  hash: string
) => {
  const url = `${apiBaseUrl}transaction/update/processing`;
  return await axios.patch<Transaction>(url, { isProcessed, hash });
};

export const getUsdEthRates = async () => {
  const data = await axios.get(
    'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD'
  );
  return data.data;
};
export const getEthUsdRates = async () => {
  const data = await axios.get(
    'https://min-api.cryptocompare.com/data/price?fsym=USD&tsyms=ETH'
  );
  return data.data;
};
